import type { Routes } from '@angular/router';
import { debugModeGuard } from '@guards/debug-mode.guard';
import { setupPageGuard } from '@guards/require-not-setup.guard';
import { requireSetupGuard } from '@guards/require-setup.guard';
import { GameComponent } from '@pages/game/game.component';
import { HomeComponent } from '@pages/home/home.component';
import { SetupComponent } from '@pages/setup/setup.component';

export const routes: Routes = [
  {
    component: HomeComponent,
    path: '',
  },
  {
    path: 'debug',
    loadComponent: () =>
      import('@pages/debug/debug.component').then((m) => m.DebugComponent),
    canActivate: [debugModeGuard],
  },
  {
    path: 'icons',
    loadComponent: () =>
      import('@pages/icons/icons.component').then((m) => m.IconsComponent),
    canActivate: [debugModeGuard],
  },
  {
    component: SetupComponent,
    path: 'setup',
    loadChildren: () =>
      import('./setup.routes').then((routes) => routes.setupRoutes),
    canActivate: [setupPageGuard],
  },
  {
    component: GameComponent,
    path: 'game',
    loadChildren: () =>
      import('./game.routes').then((routes) => routes.gameRoutes),
    canActivate: [requireSetupGuard],
  },
  {
    path: 'summary/:runId',
    loadComponent: () =>
      import('@pages/run-summary/run-summary.component').then(
        (m) => m.RunSummaryComponent,
      ),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
